import { render, staticRenderFns } from "./Annotation.vue?vue&type=template&id=136f3917&"
import script from "./Annotation.vue?vue&type=script&lang=js&"
export * from "./Annotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports